import {get} from 'lodash';

import {getCacheKey} from '/util/records.util';

export default (
  state = {},
  {
    reportName,
    reportParams,
    reportData,
    reportMeta,
    appendData,
    filtersData,
  }: any,
) =>
  // referralData,
  {
    const reportKey = getCacheKey({
      recordsName: reportName,
      recordsParams: reportParams,
      filtersData,
    });

    return {
      ...state,
      allReportData: {
        ...get(state, 'allReportData', {}),
        [reportKey]: appendData
          ? [...get(state, `allReportData.${reportKey}`, []), ...reportData]
          : reportData,
      },
      allReportMeta: {
        ...get(state, 'allReportMeta', {}),
        [reportKey]: reportMeta,
      },
      // allReferralReport: {
      //   ...get(state, 'allReferralReport', {}),
      //   [reportKey]: appendData
      //     ? [...get(state, `allReferralReport.${reportKey}`, []), ...referralData]
      //     : referralData,
      // },
    };
  };
